<div class="header" [class.only-on-print]="onlyOnPrint">
	<b class="font-family-raleway header-text"> Charametrics for {{report.name}}</b>
</div>
